// External
import React from "react";
import _ from "lodash";
import moment from "moment";

// Design system
import { EmptyState, Button } from "@toddle-edu/ds-web";
import { ChevronLeftOutlined } from "@toddle-edu/ds-icons";
import { NoDataIllustration } from "@toddle-edu/ds-theme";
import FeedListv2 from "AppComponents/FeedListv2";

// Relative
import {
  getTemplateVersionChangesColumnList,
  getTemplateVersionChangesFeedData,
} from "../../modules/TemplateLogsModalUtils";
import DownloadTableData from "../../../DownloadTableData/DownloadTableData";

// Styles
import classes from "./TemplateVersionChangesTable.scss";

const styles = {
  emptyStateSubtitleStyle: {
    maxWidth: "448px",
  },
};

const TemplateVersionChangesTable = ({
  templateVersionChanges,
  templateVersionHistory,
  selectedVersionId,
  onBack,
}) => {
  const columnList = getTemplateVersionChangesColumnList();
  const feedData = getTemplateVersionChangesFeedData({
    data: templateVersionChanges,
  });
  const selectedVersion = _.find(templateVersionHistory, {
    id: selectedVersionId,
  });
  const teacherName = _.get(selectedVersion, "updatedBy", "-");
  const updatedAt = _.get(selectedVersion, "updatedAt")
    ? moment(_.get(selectedVersion, "updatedAt")).format("DD MMM YYYY hh:mm A")
    : "-";

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.headerTop}>
          <Button
            variant="neutral"
            type="plain"
            onClick={onBack}
            icon={<ChevronLeftOutlined />}
          >
            Back to Version History
          </Button>
          <DownloadTableData
            feedData={feedData}
            columnList={columnList}
            fileName="template_version_changes_logs"
          />
        </div>
        <div className={classes.headerBottom}>
          <div className={"text-body-l"}>
            <strong>Updated by:</strong> {teacherName}
          </div>
          <div className={"text-body-l"}>
            <strong>Updated at:</strong> {updatedAt}
          </div>
          <div className={"text-body-l"}>
            <strong>Note:</strong> Only major changes made to the template are
            shown here. Some changes are not feasible to display and will not
            appear in this list.
          </div>
        </div>
      </div>
      {_.isEmpty(feedData) ? (
        <div className={classes.emptyStateContainer}>
          <EmptyState
            title="No changes found for this version"
            subtitle="There are no changes recorded for this version"
            subtitleStyle={styles.emptyStateSubtitleStyle}
            illustration={NoDataIllustration}
          />
        </div>
      ) : (
        <div className={classes.tableContainer}>
          <FeedListv2
            columnList={columnList}
            feedData={feedData}
            enableStickyHeader={true}
            headerTheme="subtle"
            showBorder={true}
          />
        </div>
      )}
    </div>
  );
};

export default TemplateVersionChangesTable;
